module.exports = __webpack_public_path__ + "static/img/ma.86c162c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ma.png
// module id = 7d64
// module chunks = 0